import { ButtonHTMLAttributes, FC, ReactNode } from 'react'
import classNames from 'classnames'
import './ControlsButton.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean
  caption?: ReactNode
}

export const ControlsButton: FC<Props> = ({ primary, caption, className, children, ...attrs }) => {
  return (
    <div className="ControlsButton">
      <button
        className={classNames('button', className, {
          '-primary': primary,
        })}
        {...attrs}
      >
        {children}
      </button>

      {caption && <div className="caption">{caption}</div>}
    </div>
  )
}
